// extracted by mini-css-extract-plugin
export default {"root":"DIopk","portraits":"KgQb-","border":"_38yY5","company":"_2_dan","firstline":"_27bFI","header":"_2tbXm","founders":"_1Bs7O","alignRight":"m4ErG","email":"_2o-ZK"};